export default "__VITE_ASSET__BDaIBaXM__"